import { getDefaultSelections } from "../../api/user/GetDefaultSelections";
import { setDefaultSelections } from "../../Redux/defaultSelections/defaultSelections";

export const loadDefaultSelections = (dispatch, done = () => { }) => {
  getDefaultSelections(
    (response) => {
      dispatch(
        setDefaultSelections({
          effective: {
            seasons: (response.data.seasons ?? []).map((season) => season.id),
            cups: (response.data.cups ?? []).map((cup) => cup.id),
            loaded: true,
          },
          preferred: {
            seasons: response.data.preferred_season_ids ?? [],
            cups: response.data.preferred_cup_ids ?? [],
          },
        })
      );
      done();
    },
    () => {
      done();
    }
  );
};
